import React from "react";
import CurrencyExchange from "./routes/CurrencyExchange";
import "./static/css/main.scss";
function App() {
    return <CurrencyExchange />;
}

export default App;
